
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/summer-tyres",
      function () {
        return require("private-next-pages/tyres/summer-tyres.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/summer-tyres"])
      });
    }
  